import { HHStack } from '@hinge-health/react-component-library';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Navigate, Route, Routes } from 'react-router-dom';
import { HingeSelectHomePlaceholder } from './components/hinge-select-home-placeholder';
import { SnackbarProvider } from './context/snackbar.context';
import { ContractsWizard } from './contracts/contracts-wizard';

export const HingeSelect = (): JSX.Element => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <SnackbarProvider>
      <HHStack
        display="flex"
        flexDirection="column"
        height="97%"
        minWidth={0}
        p={4}
        sx={{ backgroundColor: '#fff' }}
      >
        <Routes>
          <Route index element={<HingeSelectHomePlaceholder />} />
          <Route path="contracts/*" element={<ContractsWizard />} />
          <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
      </HHStack>
    </SnackbarProvider>
  </LocalizationProvider>
);
